<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <NewEditProject label="Nuevo" :project="newProject" :showDialog="showNewProjectDialog" :submitting="creatingProject" @cancel="toggleCreateProjectDialog(false)" @submit="submitNew"/>
    <NewEditProject label="Editar" :project="updateProject" :showDialog="showEditProjectDialog" :submitting="updatingProject" @cancel="toggleUpdateProjectDialog(false)" @submit="submitUpdate"/>
    <v-col cols="12">
      <v-row class="py-2 px-4" justify="space-between"  >
        <h2 style="display: inline;" id="title">Proyectos de Speech Analytics</h2>
        <v-spacer></v-spacer>
        <!-- This is temp button to refresh list when back connection reset and get empty data -->
        <v-btn color="primary" @click="getProjects">Refrescar Lista</v-btn>
        <v-btn color="primary" @click="toggleCreateProjectDialog(true)">Crear Proyecto</v-btn>
      </v-row>
    </v-col>

    <v-col cols="12" class="text-h6 pt-4" >
      <v-card>
        <v-data-table
          :must-sort="false"
          :headers="headers"
          :items="speechProjects"
          class="elevation-0"
          :loading="loadingSpeechProjects"
          :options.sync="options"
          :footer-props="{
            'items-per-page-text': 'Proyectos por página',
            'items-per-page-options': [50, 100, 200]
          }"
          :server-items-length="totalSpeechProjects"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>{{ convertTZToUserTZ(item.createdAt) | nullToDateNow | moment('DD/MM/YYYY hh:mma') }}</td>
              <td class="px-0 mx-0">
                <div class="data-table-actions d-flex justify-center align-center">
                  <v-btn icon @click="showProject(item)" color="primary" text>
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn icon @click="showUpdateProject(item)" color="primary" text>
                    <v-icon>edit</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-row>
              <v-col class="text-center" cols="12" v-if="loadingSpeechProjects">Cargando Proyectos</v-col>
              <v-col cols="12" class="red--text text-center" v-else>Aún no has creado proyectos</v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import NewEditProject from '@/pages/App/Speech/Dialogs/NewEditProject.vue'
import TimeZones from '@/mixins/TimeZones'
export default {
  components: { NewEditProject },
  computed: {
    ...mapState({
      speechProjects: state => state.speech.speechProjects,
      totalSpeechProjects: state => state.speech.totalSpeechProjects,
      loadingSpeechProjects: state => state.speech.loadingSpeechProjects,
      creatingProject: state => state.speech.creatingProject,
      showEditProjectDialog: state => state.speech.showEditProjectDialog,
      updatingProject: state => state.speech.updatingProject,
      showNewProjectDialog: state => state.speech.showNewProjectDialog,
      newProject: state => state.speech.newProject,
      updateProject: state => state.speech.updateProject
    })
  },
  data () {
    return {
      headers: [
        { text: 'Nombre del proyecto', value: 'name' },
        { text: 'Descripción', value: 'description' },
        { text: 'Fecha de Creación', value: 'createdAt' },
        { text: 'Acciones', align: 'center', sortable: false, value: '' }
      ],
      options: {}
    }
  },
  methods: {
    getProjects () {
      this.$store.commit('SET_PAGINATION_PROJECTS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getProjects')
    },
    toggleCreateProjectDialog (value) {
      this.$store.commit('TOGGLE_CREATE_PROJECT_DIALOG', value)
    },
    toggleUpdateProjectDialog (value) {
      this.$store.commit('TOGGLE_UPDATE_PROJECT_DIALOG', value)
    },
    showProject (project) {
      console.log('project')
      console.log(project)
      this.$store.commit('SET_SELECTED_PROJECT', project)
      this.$router.push('projects/' + project.id)
    },
    showUpdateProject (project) {
      this.$store.commit('SET_UPDATE_PROJECT', project)
      this.toggleUpdateProjectDialog(true)
    },
    submitNew () {
      this.$store.commit('SET_NEW_PROJECT', this.newProject)
      this.$store.dispatch('createProject')
    },
    submitUpdate () {
      this.$store.commit('SET_UPDATE_PROJECT', this.updateProject)
      this.$store.dispatch('updateProject')
    }
  },
  mixins: [TimeZones],
  watch: {
    options: {
      handler () {
        this.getProjects()
        this.$vuetify.goTo(0)
      },
      deep: true
    }
  }
}
</script>
